module.exports = __webpack_public_path__ + "static/img/vojtech.9e8facdd.jpg";